<template>
  <li class="account__ip-address-item">
    <div class="account__ip-address-item-section">
      <div class="layout--margin-bottom-xs">
        <strong>{{ ignoredIP.name }}</strong>
      </div>
      <div class="weight--light">{{ ignoredIP.ipAddress }}</div>
    </div>
    <LoadingButton
      secondary
      small
      class="layout--margin-top-sm"
      label="Remove"
      loadingLabel="Removing..."
      loadingDoneLabel="Removed!"
      :event="removeIgnoredIP"
      :loading="$wait.is('removing ip address ' + ignoredIP.id)"
      :doneLoading="saved"
    />
  </li>
</template>

<script>
import LoadingButton from "../../../components/LoadingButton";

import { mapWaitingActions } from "vue-wait";

export default {
  name: "ipAddressListItem",
  props: {
    ignoredIP: Object,
  },
  components: {
    LoadingButton,
  },
  data() {
    return {
      saved: false,
    };
  },
  methods: {
    ...mapWaitingActions("account", {
      removeIPAddress: "removing ip address",
    }),
    removeIgnoredIP: function() {
      this.saved = false;
      this.$wait.start("removing ip address " + this.ignoredIP.id);
      this.removeIPAddress(this.ignoredIP).then(() => {
        this.saved = true;
        this.$wait.end("removing ip address " + this.ignoredIP.id);
      });
    },
  },
};
</script>

<style></style>
